import type { FC, SVGProps } from "react";

const IconUserRound: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 16 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		stroke="currentColor"
		{...props}
	>
		<path
			d="M7.99992 9.83333C10.3011 9.83333 12.1666 7.96785 12.1666 5.66667C12.1666 3.36548 10.3011 1.5 7.99992 1.5C5.69873 1.5 3.83325 3.36548 3.83325 5.66667C3.83325 7.96785 5.69873 9.83333 7.99992 9.83333Z"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M14.6666 16.4997C14.6666 14.7316 13.9642 13.0359 12.714 11.7856C11.4637 10.5354 9.76803 9.83301 7.99992 9.83301C6.23181 9.83301 4.53612 10.5354 3.28587 11.7856C2.03563 13.0359 1.33325 14.7316 1.33325 16.4997"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);

export default IconUserRound;
